import { NgModule, Optional, SkipSelf, ModuleWithProviders } from "@angular/core";
import {MetamaskService} from "../core/service/metamask-services";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthenticationService } from "../core/service/authentication.service";
import { AdapterService } from "../core/service/adapter.service";
import { AppHttpInterceptor } from "../core/interceptor/app-http-interceptor";
import { AuthenticationGuard } from "../core/guards/authentication";
import { ToastService } from "../core/service/toast.service";

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,

  ],
  exports: [
    HttpClientModule,
    
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        "CoreModule is already loaded. Import it in the AppModule only");
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: "AdaptersService", useClass: AdapterService },
        { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
        AuthenticationGuard,
        AuthenticationService,
        ToastService,
        MetamaskService,
     
    
      ]
    }
  }
}
